import { useQuery } from "@tanstack/react-query";
import useApi from "../utils/useApi";

export default function useExistsZoneWithoutCollection() {
  const { existsZoneWithoutCollection: fetchExistsZoneWithoutCollection } =
    useApi();

  const { data, isLoading } = useQuery({
    queryKey: ["existsZoneWithoutCollection"],
    queryFn: fetchExistsZoneWithoutCollection,
  });

  const existsZoneWithoutCollection = data?.data.exists_zone_without_collection;

  return {
    data: existsZoneWithoutCollection,
    isLoading,
  };
}
